import Vue from 'vue'
import request from '@/helpers/request'
import router from '@/router'
import store from '@/store'
import moment from 'moment'
import helper from '@/store/finances/helper'
import snack from '@/helpers/snack'
import ServerValidationError from '@/helpers/ServerValidationError'

export default {
  GET_SERVICES: ({ commit, state }, payload) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.services.all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      const data = response.data.data
      commit('setServices', state.services.concat(data.items))
      commit('setServiceFilters', data.filters)
      commit('setLoad', false)
    })
  },
  APPEND_SERVICES: ({ commit, state }, payload) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.services.all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        _.forEach(data.items, (item, index) => {
          if (item && item.id == store.getters.service.id) {
            data.items.splice(index, 1)
          }
        })
        commit('setServices', state.services.concat(data.items))
        commit('setServiceFilters', data.filters)
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_SERVICE_WITH_SERVICES: ({ commit, state }, { serviceID, priceCompanyId }) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.services.one.replace('$1', serviceID)}`,
      {
        params: {
          with: 'priceActual;groups;images;prices;prices.unit',
          price_company_id: priceCompanyId,
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const prices = _.filter(response.data.data.prices, price => price.company_id === priceCompanyId)
          const service = Object.assign(response.data.data, { prices })
          commit('setService', service)
          commit('setTitle', state.service.title)
          // Get services
          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.services.all}`,
            {
              params: {
                orderBy: 'popular',
                sortedBy: 'desc',
                offset: 0,
                limit: 30,
                price_company_id: priceCompanyId,
              },
            },
            true,
          )
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          // const items = array.removeByID(data.items, state.service.id);
          // TODO Refactoring PG-388
          _.forEach(data.items, (item, index) => {
            if (item && item.id == store.getters.service.id) {
              data.items.splice(index, 1)
            }
          })
          data.items.unshift({ ...state.service })
          commit('setServices', data.items)
          commit('setServiceFilters', data.filters)
          // Get all service categories
          return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.all}`, {}, true)
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setServiceCategories', data.items)

          // Get service form
          return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.services.form}`, {}, true)
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setServiceForm', data.form)
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      })
  },
  GET_SERVICE: ({ commit, state }, { serviceID, priceCompanyId }) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.services.one.replace('$1', serviceID)}`,
      {
        params: {
          with: 'priceActual;groups;images;prices;prices.unit',
          price_company_id: priceCompanyId,
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const prices = _.filter(response.data.data.prices, price => price.company_id === priceCompanyId)
        const service = Object.assign(response.data.data, { prices })
        commit('setService', service)
        commit('setTitle', service.title)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  async UPDATE_SERVICE({ commit, state, getters, dispatch }, { companyId }) {
    commit('setLoad', true)
    let group = null
    const arrGroup = getters['searchServiceCategories/activeServices']
    if (!_.isEmpty(arrGroup)) {
      group = arrGroup
    }
    const formData = helper({
      price_company_id: companyId ? companyId : store.getters.user.company_id,
      title: state.service.title,
      service_sub_category_id: state.service.service_sub_category_id,
      subtitle: state.service.subtitle,
      article: state.service.article,
      service_category_id: state.service.service_category_id,
      price: state.service.price_actual ? state.service.price_actual.price : null,
      duration: state.service.duration,
      title_online: state.service.title_online,
      company_ids: state.service.company_ids,
      title_cashier: state.service.title_cashier,
      is_countable: Number(state.service.is_countable) || 0,
      show_aggregator: Number(state.service.show_aggregator) || 0,
      show_crm: Number(state.service.show_crm) || 0,
      popular: state.service.popular,
      priority: state.service.priority,
      description: state.service.description,
      big_image: state.service.big_image,
      show_description: state.service.show_description ? 1 : 0,
      ignore_window_ratio: Number(state.service.ignore_window_ratio) || 0,
      ignore_windows: Number(state.service.ignore_windows) || 0,
      show_info: Number(state.service.show_info) || 0,
      info: state.service.info,
      // TODO: Bind 'barcode' field
      barcode: 'H00028',
      group: group,
      image: [state.service.image],
      _method: 'PUT',
      seo_title: state.service.seo_title,
      is_hit: state.service.is_hit,
      is_new: state.service.is_new,
      is_promoted: state.service.is_promoted,
      seo_description: state.service.seo_description,
      ignore_price_category_ids: state.service.ignore_price_category_ids?.map(item => parseInt(item)) || [],
    })
    try {
      await request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.services.one.replace('$1', state.service.id)}`,
        {
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Requested-With': 'XMLHttpRequest',
            'X-Locale': navigator.language.substr(0, 2),
          },
        },
        true,
      )
      let pricesAddRequests = []
      let pricesRemoveRequests = []
      if (getters.servicePriceIntervalsAdded.length) {
        pricesAddRequests = _.map(
          _.filter(
            getters.servicePriceIntervalsAdded,
            i => !_.includes(getters.servicePriceIntervalsAddedMarkedForRemoval, i),
          ),
          params => {
            /* Params
          price,
          company_id,
          price_company_id,
          begin_at,
          end_at
          */
            return request(
              'POST',
              `${Vue.config.server}/${Vue.config.modules.crm.api.services.price.replace(
                '$service_id',
                state.service.id,
              )}`,
              params,
              true,
            )
          },
        )
      }
      if (getters.servicePriceIntervalsRemoved.length) {
        pricesRemoveRequests = _.map(getters.servicePriceIntervalsRemoved, interval => {
          return request(
            'DELETE',
            `${Vue.config.server}/${Vue.config.modules.crm.api.services.priceDestroy
              .replace('$service_id', interval.id)
              .replace('$price_id', interval.id)}`,
            {},
            true,
          )
        })
      }
      await Promise.all([...pricesAddRequests, ...pricesRemoveRequests])
      commit('changeService', { key: state.service.id, value: state.service })
      commit('setTitle', state.service.title)
      await dispatch('GET_SERVICE', { serviceID: state.service.id, priceCompanyId: companyId })
      commit('setServicePriceIntervalsAdded', [])
      commit('setServicePriceIntervalsRemoved', [])
      commit('setServicePriceIntervalsAddedMarkedForRemoval', [])

      commit('setServiceErrors', null)

      snack.add(Vue.config.localization.ru.savedMessage, 'primary')
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.errorSavingMessage)
      commit('setServiceErrors', e.data.errors)
    } finally {
      commit('setLoad', false)
    }
  },

  CREATE_SERVICE: ({ commit, state }, { companyId }) => {
    commit('setLoad', true)

    let group = null
    if (state.service.group != null) {
      group = store.getters['searchServiceCategories/activeServices']
    }

    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.services.all}`,
      {
        title: state.service.title,
        subtitle: state.service.subtitle,
        seo_title: state.service.seo_title,
        seo_description: state.service.seo_description,
        article: state.service.article,
        service_sub_category_id: state.service.service_sub_category_id,
        service_category_id: state.service.service_category_id,
        price: state.service.price_actual ? state.service.price_actual.price : null,
        company_id: companyId,
        duration: state.service.duration,
        company_ids: state.service.company_ids,
        title_online: state.service.title_online,
        title_cashier: state.service.title_cashier,
        is_countable: Number(state.service.is_countable) || 0,
        show_aggregator: Number(state.service.show_aggregator) || 0,
        show_crm: Number(state.service.show_crm) || 0,
        popular: state.service.popular,
        priority: state.service.priority,
        description: state.service.description,
        big_image: state.service.big_image,
        show_description: state.service.show_description ? 1 : 0,
        ignore_window_ratio: Number(state.service.ignore_window_ratio) || 0,
        ignore_windows: Number(state.service.ignore_windows) || 0,
        show_info: Number(state.service.show_info) || 0,
        info: state.service.info,
        is_hit: state.service.is_hit,
        is_new: state.service.is_new,
        is_promoted: state.service.is_promoted,
        ignore_price_category_ids: state.service.ignore_price_category_ids?.map(item => parseInt(item)) || [],
        // TODO: Bind 'barcode' field
        barcode: 'H00028',
        group: group,
      },
      true,
    )
      .then(
        response => {
          if (response.data.result === 'success') {
            const data = response.data.data

            commit('setServiceField', { key: 'id', value: data.id })
            commit('setTitle', state.service.title)
            commit('unshiftServices', { ...state.service })

            return request(
              'POST',
              `${Vue.config.server}/${Vue.config.modules.crm.api.services.price.replace(
                '$service_id',
                state.service.id,
              )}`,
              {
                price: state.service.price_actual ? state.service.price_actual.price : null,
                price_company_id: companyId,
                company_id: companyId,
                begin_at: moment(new Date()).format(Vue.config.format.serverDate),
                end_at: null,
              },
              true,
            )
          } else {
            // TODO: Show error dialog
          }
        },
        response => {
          commit('setLoad', false)
        },
      )
      .then(
        response => {
          if (response.data.result === 'success') {
            router.push({ path: Vue.config.modules.crm.route.services.one.replace('$1', state.service.id) })
            commit('setLoad', false)

            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.savedMessage,
            })
          } else {
            // TODO: Show error dialog
          }
        },
        response => {
          commit('setLoad', false)
        },
      )
  },
  DELETE_SERVICE: ({ commit, state }) => {
    commit('setLoad', true)
    request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.services.one.replace('$1', state.service.id)}`,
      {},
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          commit('deleteService', state.service.id)
          const servicesLength = state.services.length

          if (servicesLength != 0) {
            commit('setService', state.services[0])
            commit('setServiceField', { key: 'id', value: state.services[0].id })
            commit('setTitle', state.services[0].title)

            commit('setServiceErrors', null)
            commit('setLoad', false)

            router.push({ path: Vue.config.modules.crm.route.services.one.replace('$1', 1) })

            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.deleteMessage,
            })
          } else {
            router.push({ path: Vue.config.modules.crm.route.services.all })
          }
        } else {
          commit('setServiceErrors', null)
          commit('setLoad', false)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'error',
            text: Vue.config.localization.ru.notFoundMessage,
          })
          // TODO: Show error dialog
        }
      },
      e => {
        ServerValidationError.notify(e, 'customerValidation')
        commit('setLoad', false)
      },
    )
  },
}
